import { types } from "../../types/types";
import { EMPADRONAMIENTO_MEDICACION_ESTADOS, EMPADRONAMIENTO_SOLICITUDES_ESTADOS } from "../../utils/constants";

const initialState = {
  activeStep: 0,
  afiliadoSeleccionado: null,
  estadoSolicitudes: EMPADRONAMIENTO_SOLICITUDES_ESTADOS.EN_CARGA?.toString(),
  estadoSolicitudesConsulta: /*EMPADRONAMIENTO_SOLICITUDES_ESTADOS.ACTIVA?.toString()*/ null,
  estadoMedicacion: EMPADRONAMIENTO_MEDICACION_ESTADOS.EN_CARGA?.toString(),
  estadoMedicacionConsulta: /*EMPADRONAMIENTO_MEDICACION_ESTADOS.AUTORIZADA?.toString()*/ null,
  medicamentos: [],
  medicamentosDeEmpadronamiento: [],
  documentacion: [],
  diagnosticos: [],
  showForm: true,
  solicitudes: [],
  solicitudesHistorial: [],
  solicitudesHistorialMed: [],
  solicitudesHistorialMigra: [],
  solicitudesActivas: [],
  solicitudesContadores: [],
  solicitudSeleccionada: null,
  tiposEmpadronamiento: [],
  tiposDocumentacion: [],
  itemsTiposDocu: [],
  trackingSolicitudEmp: [],
  trackingSolicitudMed: [],
  documentacionMedicacion: [],
  idTipoEmpadronamiento: null,
  disponibilidadMedicamentosScienza: [],
  patologiasEmpadronamiento: [],
  tiposDocumentacionMedicacion: [],
  notasEmp: [],
  notasMed: [],
  tiposNotasEmp: [],
  trackingScienza: [],
  trackingNosConecta: [],
  conveniosScienzaEmp: [],
  alertas:[]
};

export const EmpadronamientoReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.empadronamientoClearReducer:
      return {
        ...initialState,
        idTipoEmpadronamiento: state.idTipoEmpadronamiento,
      };
    case types.empadronamientoUpdateEstadoSolicitudes:
      return {
        ...state,
        estadoSolicitudes: action.payload,
      };
    case types.empadronamientoUpdateEstadoMedicacion:
      return {
        ...state,
        estadoMedicacion: action.payload,
      };
    case types.empadronamientoUpdateEstadoSolicitudesConsulta:
      return {
        ...state,
        estadoSolicitudesConsulta: action.payload,
      };
    case types.empadronamientoUpdateEstadoMedicacionConsulta:
      return {
        ...state,
        estadoMedicacionConsulta: action.payload,
      };
    case types.empadronamientoSetStep:
      return {
        ...state,
        activeStep: action.payload,
      };
    case types.empadronamientoSetAfiliadoSeleccionado:
      return {
        ...state,
        afiliadoSeleccionado: action.payload,
      };
    case types.empadronamientoCleanAfiliadoSeleccionado:
      return {
        ...state,
        afiliadoSeleccionado: null,
      };
    case types.empadronamientoGetTiposEmpadronamientosSuccess:
      return {
        ...state,
        tiposEmpadronamiento: action.payload,
      };
    case types.empadronamientoGetTiposEmpadronamientosError:
      return {
        ...state,
        tiposEmpadronamiento: [],
      };
    case types.empadronamientoGetSolicitudesSuccess:
      return {
        ...state,
        solicitudes: action.payload,
      };
    case types.empadronamientoGetSolicitudesHistorialSuccess:
      return {
        ...state,
        solicitudesHistorial: action.payload,
      };
    case types.empadronamientoGetSolicitudesHistorialError:
      return {
        ...state,
        solicitudesHistorial: [],
      };
    case types.empadronamientoGetSolicitudesHistorialMedSuccess:
      return {
        ...state,
        solicitudesHistorialMed: action.payload,
      };
    case types.empadronamientoGetSolicitudesHistorialMedError:
      return {
        ...state,
        solicitudesHistorialMed: [],
      };
    case types.empadronamientoGetSolicitudesHistorialMigraSuccess:
      return {
        ...state,
        solicitudesHistorialMigra: action.payload,
      };
    case types.empadronamientoGetSolicitudesHistorialMigraError:
      return {
        ...state,
        solicitudesHistorialMigra: [],
      };
    case types.empadronamientoGetSolicitudesActivasSuccess:
      return {
        ...state,
        solicitudesActivas: action.payload,
      };
    case types.empadronamientoCleanSolicitudes:
      return {
        ...state,
        solicitudes: [],
      };
    case types.empadronamientoAnularSolicitudSuccess:
      return {
        ...state,
        solicitudes: state.solicitudes.filter(item => item.idSolicitud !== action.payload)
      };
    case types.empadronamientoGetSolicitudesError:
      return {
        ...state,
        solicitudes: [],
      };
    case types.empadronamientoGetSolicitudesActivasError:
      return {
        ...state,
        solicitudesActivas: [],
      };
    case types.empadronamientoGetContadoresSolicitudesSuccess:
      return {
        ...state,
        solicitudesContadores: action.payload,
      };
    case types.empadronamientoGetContadoresSolicitudesError:
      return {
        ...state,
        solicitudesContadores: [],
      };
    case types.empadronamientoAddMedicamento:
      const medicamentosAux = Array.isArray(state.medicamentos)
        ? [...state.medicamentos]
        : [];
      return {
        ...state,
        medicamentos: [...medicamentosAux, action.payload],
      };
    case types.empadronamientoReplaceMedicamentosPorSeleccionados:
      return {
        ...state,
        medicamentos: action.payload,
      };
    case types.empadronamientoSetSolicitudSeleccionadaMedicamentos:
      return {
        ...state,
        medicamentos: action.payload
      };
    case types.empadronamientoSetSolicitudSeleccionadaDiagnosticos:
      return {
        ...state,
        diagnosticos: action.payload
      };
    case types.empadronamientoSetSolicitudSeleccionada:
      return {
        ...state,
        solicitudSeleccionada: action.payload,
      };
    case types.empadronamientoCleanSolicitudSeleccionada:
      return {
        ...state,
        solicitudSeleccionada: null,
      };
    case types.empadronamientoSetShowForm:
      return {
        ...state,
        showForm: action.payload,
      };
    case types.empadronamientoSetMedicamentos:
      return {
        ...state,
        medicamentos: action.payload,
      };
    case types.empadronamientoGetMedicamentosSuccess:
      return {
        ...state,
        medicamentos: action.payload,
      };
    case types.empadronamientoUpdateSolicitudSeleccionada:
      return {
        ...state,
        solicitudSeleccionada: action.payload,
      };
    case types.empadronamientoGetTiposDocumentacionSuccess:
      return {
        ...state,
        tiposDocumentacion: action.payload,
      };
    case types.empadronamientoGetTiposDocumentacionError:
      return {
        ...state,
        tiposDocumentacion: [],
      };
    case types.empadronamientoGetDocumentacionSuccess:
      return {
        ...state,
        documentacion: action.payload,
      };
    case types.empadronamientoGetDocumentacionError:
      return {
        ...state,
        documentacion: [],
      };
    case types.empadronamientoGetMedicamentosEmpSuccess:
      return {
        ...state,
        medicamentosDeEmpadronamiento: action.payload,
      };
    case types.empadronamientoGetMedicamentosEmpError:
      return {
        ...state,
        medicamentosDeEmpadronamiento: [],
      };
    case types.empadronamientoGetTrackingSolicitudSuccess:
      return {
        ...state,
        trackingSolicitudEmp: action.payload,
      };
    case types.empadronamientoGetTrackingSolicitudError:
      return {
        ...state,
        trackingSolicitudEmp: [],
      };
    case types.empadronamientoGetTrackingSolicitudMedicacionSuccess:
      return {
        ...state,
        trackingSolicitudMed: action.payload,
      };
    case types.empadronamientoGetTrackingSolicitudMedicacionError:
      return {
        ...state,
        trackingSolicitudMed: [],
      };
    case types.empadronamientoGetDocumentacionMedicacionSuccess:
      return {
        ...state,
        documentacionMedicacion: action.payload,
      };
    case types.empadronamientoSetTipoEmpadronamiento:
      return {
        ...state,
        idTipoEmpadronamiento: action.payload
      };
    case types.empadronamientoGetDisponibilidadScienzaSucces:
      return {
        ...state,
        disponibilidadMedicamentosScienza: action.payload
      }
    case types.empadronamientoGetDisponibilidadScienzaError:
      return {
        ...state,
        disponibilidadMedicamentosScienza: []
      }
    case types.empadronamientosGetPatologias:
      return {
        ...state,
        patologiasEmpadronamiento: action.payload
      }
    case types.empadronamientoGetTiposDocumentacionMedicacionSuccess:
      return {
        ...state,
        tiposDocumentacionMedicacion: action.payload
      }
    //NOTAS EMP
    case types.empadronamientoGetNotasSuccess:
      return {
        ...state,
        notasEmp: action.payload,
      };
    case types.empadronamientoGetNotasError:
      return {
        ...state,
        notasEmp: null,
      };
    //NOTAS MED 
    case types.empadronamientoMedicacionGetNotasSuccess:
      return {
        ...state,
        notasMed: action.payload,
      };
    case types.empadronamientoMedicacionGetNotasError:
      return {
        ...state,
        notasMed: null,
      };
    //TIPOS NOTAS
    case types.empadronamientoGetTiposNotasSuccess:
      return {
        ...state,
        tiposNotasEmp: action.payload,
      };
    case types.empadronamientoGetTiposNotasError:
      return {
        ...state,
        tiposNotasEmp: [],
      };
    case types.empadronamientoGetTrackingScienzaSuccess:
      return {
        ...state,
        trackingScienza: action.payload,
      };
    case types.empadronamientoGetTrackingScienzaError:
      return {
        ...state,
        trackingScienza: [],
      };
    case types.empadronamientoGetTrackingNosConectaSuccess:
      return {
        ...state,
        trackingNosConecta: action.payload,
      };
    case types.empadronamientoGetTrackingNosConectaError:
      return {
        ...state,
        trackingNosConecta: [],
      };
    case types.empadronamientoGetConveniosScienzaSuccess:
      return {
        ...state,
        conveniosScienzaEmp: action.payload,
      };
    case types.empadronamientoGetConveniosScienzaError:
      return {
        ...state,
        conveniosScienzaEmp: [],
      };
    case types.empadronamientoAlertasSuccess:
      return{
        ...state,
        alertas: action.payload
      };
       case types.empadronamientoAlertasError:
      return{
        ...state,
        alertas: []
      };
    default:
      return state;
  }

};
